// extracted by mini-css-extract-plugin
module.exports = {"loading":"dV","fullscreenWrapper":"dW","centeredSpinner":"dX","rotation":"dY","withoutLayer":"dZ"};